import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getAccountStorages, getAccountStoragesByEntityId } from "./actions";

export const storageEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = storageEntityAdapter.getInitialState({
  count: 0,
});

export const storageSlice = createSlice({
  name: "storage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAccountStorages.fulfilled, (state, action) => {
      if (action.payload.success) {
        storageEntityAdapter.setAll(state, action.payload.storages);
        state.count = action.payload?.storages.length || 0;
      }
    });
    builder.addCase(getAccountStoragesByEntityId.fulfilled, (state, action) => {
      if (action.payload.success) {
        storageEntityAdapter.setAll(state, action.payload.storages);
      }
    });
  },
});
export default storageSlice.reducer;
